import { combineReducers } from 'redux';

import consultaNaturalidade from './consultarNaturalidade/reducer';
// import consultaCEP from './cep/reducer';

export default combineReducers({
	consultaNaturalidade,
	// consultaCEP,
});
